import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledPreferenceCard,
  Heading,
  Content,
  HeaderTwo,
  Paragraph,
} from './styles.js';

export const PreferenceCard = ({
  title = '',
  subtitle = '',
  children,
  error = false,
}) => {
  return (
    <StyledPreferenceCard error={error}>
      {title && (
        <Heading>
          <HeaderTwo error={error}>{title}</HeaderTwo>
          <Paragraph>{subtitle}</Paragraph>
        </Heading>
      )}
      <Content>{children}</Content>
    </StyledPreferenceCard>
  );
};

PreferenceCard.displayName = 'PreferenceCard';

PreferenceCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
};
